/* Geteiltes Live-Bewertungs-Modul (Reviews.io) — sitewide via layout/theme.liquid geladen.
   Genutzt von: sections/announcement-bar.liquid, sections/hero-section-slider-2026.liquid.
   Ein Fetch pro Store-ID pro Seitenaufruf, egal wie viele Sections sich registrieren. */
if (!window.IngardenReviewsStats) {
  window.IngardenReviewsStats = (function () {
    var listeners = {};
    var fetching = {};
    var cacheTtl = 6 * 60 * 60 * 1000; // 6h

    function compute(stats) {
      var companyCount = (stats.company_review_stats && stats.company_review_stats.total_reviews) || 0;
      var productCount = (stats.product_review_stats && stats.product_review_stats.total_reviews) || 0;
      var thirdCount = (stats.third_party_review_stats && stats.third_party_review_stats.total_reviews) || 0;
      var companyAvg = parseFloat(stats.company_review_stats && stats.company_review_stats.average_rating) || 0;
      var productAvg = parseFloat(stats.product_review_stats && stats.product_review_stats.average_rating) || 0;
      var thirdAvg = parseFloat(stats.third_party_review_stats && stats.third_party_review_stats.average_rating) || 0;
      var totalCount = companyCount + productCount + thirdCount;
      if (!totalCount) return null;
      var weighted = (companyAvg * companyCount + productAvg * productCount + thirdAvg * thirdCount) / totalCount;
      return { rating: weighted, count: totalCount };
    }

    function notify(storeId, computed) {
      (listeners[storeId] || []).forEach(function (cb) {
        try {
          cb(computed);
        } catch (e) {}
      });
    }

    function fetchFresh(storeId, cacheKey) {
      if (fetching[storeId]) return;
      fetching[storeId] = true;
      fetch('https://api.reviews.io/stats/all?store=' + encodeURIComponent(storeId))
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (stats) {
          fetching[storeId] = false;
          if (!stats) return;
          try {
            localStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), stats: stats }));
          } catch (e) {}
          notify(storeId, compute(stats));
        })
        .catch(function () {
          fetching[storeId] = false;
        });
    }

    // --- Pro-Produkt-Rating (PDP) ---
    // Nutzt Reviews.io's öffentlichen, CORS-offenen rating-batch-Endpoint (denselben, den ihr
    // eigenes ruk_rating_snippet-Widget intern aufruft — reverse-engineered aus deren
    // öffentlichem widget.reviews.io/rating-snippet/dist.js). Liefert echte Pro-SKU-Daten,
    // damit wir sie im Banner/Hero-Format (Gold, "4,79/5 (158 Rezensionen)") statt im festen
    // Snippet-Eigenformat ("★★★★★ (158 Reviews)", Englisch) rendern können.
    var productListeners = {};
    var productFetching = {};

    function computeProduct(entries) {
      var totalCount = 0;
      var weighted = 0;
      (entries || []).forEach(function (entry) {
        var avg = parseFloat(entry.average_rating) || 0;
        var cnt = parseInt(entry.num_ratings, 10) || 0;
        totalCount += cnt;
        weighted += avg * cnt;
      });
      if (!totalCount) return null;
      return { rating: weighted / totalCount, count: totalCount };
    }

    function notifyProduct(cacheKey, computed) {
      (productListeners[cacheKey] || []).forEach(function (cb) {
        try {
          cb(computed);
        } catch (e) {}
      });
    }

    function fetchProductFresh(storeId, skuString, cacheKey) {
      if (productFetching[cacheKey]) return;
      productFetching[cacheKey] = true;
      fetch(
        'https://api.reviews.io/product/rating-batch?sku=' +
          encodeURIComponent(skuString) +
          '&store=' +
          encodeURIComponent(storeId)
      )
        .then(function (res) {
          return res.ok ? res.json() : null;
        })
        .then(function (entries) {
          productFetching[cacheKey] = false;
          if (!entries) return;
          try {
            localStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), entries: entries }));
          } catch (e) {}
          notifyProduct(cacheKey, computeProduct(entries));
        })
        .catch(function () {
          productFetching[cacheKey] = false;
        });
    }

    return {
      // callback(computed) wird aufgerufen: sofort mit gecachten Daten (falls frisch genug),
      // dann erneut, sobald der Live-Fetch zurückkommt. computed ist null, wenn (noch) keine Daten da sind.
      onUpdate: function (storeId, callback) {
        storeId = storeId || 'ingarden-us.myshopify.com';
        listeners[storeId] = listeners[storeId] || [];
        listeners[storeId].push(callback);

        var cacheKey = 'irs_stats_' + storeId;
        var cached = null;
        try {
          var raw = localStorage.getItem(cacheKey);
          if (raw) {
            var parsed = JSON.parse(raw);
            if (parsed && parsed.ts && Date.now() - parsed.ts < cacheTtl) {
              cached = parsed.stats;
            }
          }
        } catch (e) {
          /* localStorage evtl. nicht verfügbar — kein Problem */
        }

        if (cached) callback(compute(cached));
        fetchFresh(storeId, cacheKey);
      },

      // Wie onUpdate, aber pro Produkt: skuString ist derselbe ";"-getrennte String wie im
      // data-sku-Attribut des nativen ruk_rating_snippet (Handle;SKU(s);Variant-ID(s)).
      onProductUpdate: function (storeId, skuString, callback) {
        storeId = storeId || 'ingarden-us.myshopify.com';
        var cacheKey = 'irs_product_' + storeId + '_' + skuString;
        productListeners[cacheKey] = productListeners[cacheKey] || [];
        productListeners[cacheKey].push(callback);

        var cached = null;
        try {
          var raw = localStorage.getItem(cacheKey);
          if (raw) {
            var parsed = JSON.parse(raw);
            if (parsed && parsed.ts && Date.now() - parsed.ts < cacheTtl) {
              cached = parsed.entries;
            }
          }
        } catch (e) {
          /* localStorage evtl. nicht verfügbar — kein Problem */
        }

        if (cached) callback(computeProduct(cached));
        fetchProductFresh(storeId, skuString, cacheKey);
      }
    };
  })();
  // Signalisiert Consumer-Scripts, die VOR diesem (deferred geladenen) Modul ausgeführt werden
  // konnten — z.B. inline <script>-Blöcke in Sections wie hero-section-slider-2026.liquid,
  // die synchron beim Parsen laufen, also vor jedem defer-Script — dass das Modul jetzt bereit ist.
  window.dispatchEvent(new CustomEvent('IngardenReviewsStatsReady'));
}

// PDP-Live-Rating (Namespace pdr, siehe snippets/pdp-live-rating.liquid): dieses Script ist
// selbst defer-geladen (garantiert nach dem Parsen der Seite), scannt daher direkt nach
// Elementen — kein Event-Handshake nötig wie beim Hero (dessen eigenes Inline-Script vor
// diesem Modul laufen kann).
document.querySelectorAll('[data-ingarden-product-rating]').forEach(function (el) {
  var sku = el.getAttribute('data-sku');
  if (!sku) return;
  var storeId = el.getAttribute('data-store') || 'ingarden-us.myshopify.com';
  window.IngardenReviewsStats.onProductUpdate(storeId, sku, function (computed) {
    if (!computed) return;
    var ratingStr = computed.rating.toFixed(2).replace('.', ',');
    var countStr = Math.floor(computed.count).toLocaleString('de-DE');
    var ratingEl = el.querySelector('[data-pdr-rating]');
    var countEl = el.querySelector('[data-pdr-count]');
    if (ratingEl) ratingEl.innerHTML = '<strong>' + ratingStr + '/5</strong>';
    if (countEl) countEl.textContent = '(' + countStr + ' Rezensionen)';
  });
});